import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  DeliveryEventNotificationHistoryPostableType,
  ResponseMessageType,
} from "~/domains";

type RequestDataType = {
  body: {
    postableType?: DeliveryEventNotificationHistoryPostableType;
    employeeRoleId?: number;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .put<ResponseMessageType>("/api/members/delivery_notifications", {
      ...body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDeliveryNotificationsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
